var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('section', {
    staticClass: "ugc-custom-pattern-upload"
  }, [_c('div', {
    staticClass: "ugc-custom-pattern-upload-wrapper"
  }, [_c('button', {
    staticClass: "button ugc-tray-wrapper-button",
    style: {
      'background-image': "url(".concat(_vm.customsAssets, "/images/customizer/pattern_maker_cta_bg.png)")
    },
    attrs: {
      "type": "button",
      "disabled": _vm.isPatternDisabled
    },
    on: {
      "mouseover": function mouseover($event) {
        return _vm.handleHover($event, true);
      },
      "mouseleave": function mouseleave($event) {
        return _vm.handleHover($event, false);
      },
      "click": _vm.clicked
    }
  }, [_vm._v("\n      " + _vm._s(_vm.textLabel || _vm.translations[_vm.inputLabel]) + "\n    ")])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }